import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { createApiResponseSchema } from '../../../utils';
import { partnerApiPath } from '../../apiPath';
import { partnerHttpClient } from '../../httpClient';

const GetSeedingAnnouncementDateRequestSchema = z
  .object({
    recruitmentEndAt: z.string().describe('모집 종료일 (YYYY-MM-DD)'),
  })
  .describe('GetSeedingAnnouncementDateRequestSchema');

export type GetSeedingAnnouncementDateRequest = z.infer<
  typeof GetSeedingAnnouncementDateRequestSchema
>;

const SeedingAnnouncementDateSchema = z
  .object({
    announcementDate: z.string().describe('선정 발표일 (모집 종료일 +4영업일, 주말·공휴일 제외)'),
    shippingDeadlineDate: z
      .string()
      .describe('발송 마감일 (모집 종료일 +7영업일, 주말·공휴일 제외)'),
  })
  .describe('SeedingAnnouncementDateSchema');

export type SeedingAnnouncementDate = z.infer<typeof SeedingAnnouncementDateSchema>;

const GetSeedingAnnouncementDateResponseSchema = createApiResponseSchema(
  SeedingAnnouncementDateSchema,
);

export type GetSeedingAnnouncementDateResponse = z.infer<
  typeof GetSeedingAnnouncementDateResponseSchema
>;

export const getSeedingAnnouncementDate = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(GetSeedingAnnouncementDateRequestSchema),
    async (query: GetSeedingAnnouncementDateRequest) =>
      executeStandardRequest(async () =>
        partnerHttpClient.get<GetSeedingAnnouncementDateResponse>(
          partnerApiPath.getSeedingAnnouncementDate,
          query,
        ),
      ),
    validateApiResponse(GetSeedingAnnouncementDateResponseSchema),
  ),
);
